export default "__VITE_ASSET__a85XboDo__"